import { createAction } from 'redux-actions';

export const SET_COMMENTS_OPEN = 'CLIENT.COMMENTS.SET_OPEN';
export const SET_HAS_NEW_COMMENTS = 'CLIENT.COMMENTS.SET_HAS_NEW';
export const SET_OPEN_ON_LOAD = 'CLIENT.COMMENTS.SET_OPEN_ON_LOAD';

export const setCommentsOpen = createAction<boolean>(SET_COMMENTS_OPEN);
export const setHasNewComments = createAction<boolean>(SET_HAS_NEW_COMMENTS);
export const setOpenCommentsOnLoad = createAction<boolean>(SET_OPEN_ON_LOAD);
